import React from 'react';
import styles from './TranslucentOverlay.module.scss';
import { Button, Image, NonDismissibleOverlay, T, TList } from '@colonist/ui';
import IconCheck from '@static/images/icon_check.svg';
/** Translucent non dismissible overlay with an optional action btn */ export const TranslucentOverlay = ({ title, body, confirmLabel, onConfirm })=>{
    return /*#__PURE__*/ React.createElement(NonDismissibleOverlay, {
        backgroundOpacity: "translucent"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: styles.title
    }, /*#__PURE__*/ React.createElement(T, {
        id: title
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.body
    }, /*#__PURE__*/ React.createElement(TList, {
        id: body
    })), onConfirm != undefined && /*#__PURE__*/ React.createElement(Button, {
        variant: "primary",
        size: "sm",
        onClick: onConfirm
    }, confirmLabel != undefined ? /*#__PURE__*/ React.createElement(T, {
        id: confirmLabel
    }) : /*#__PURE__*/ React.createElement(Image, {
        className: styles.buttonIcon,
        image: {
            src: IconCheck,
            alt: 'strings:colonistCommon.buttons.confirm'
        }
    })));
};
